import InventoryListingV2 from './InventoryListingV2';
export default InventoryListingV2;